module.exports = __webpack_public_path__ + "img/product7.b4fe9f81.png";